<footer>
    <div class="footer-container">
        <div class="footer-main">
            <!-- Brand Section -->
            <div class="footer-brand">
                <div class="footer-logo">
                    <a class="navbar-brand" href="/">
                        <!-- <img src="assets/img/logo/logo.png" class="logo-display" alt="logo"> -->
                        <img src="assets/img/logo/logo-dark.png" class="logo-scrolled" alt="logo">
                    </a>
                </div>

                <div class="footer-contact">
                    <div class="contact-item">
                        <i class="fas fa-headset"></i>
                        <div>
                            <div style="font-size: 12px; margin-bottom: 4px;">{{ '24/7 Call Service' | lang }}</div>
                            <a href="tel:+97104273185" class="contact-phone">+971 (04) 273 1885</a>
                        </div>
                    </div>

                    <div class="contact-item">
                        <i class="fas fa-map-marker-alt"></i>
                        <div>{{ 'Office No 312 NBQ Building, Bank Street, Burjuman, Dubai - UAE' | lang }}</div>
                    </div>

                    <div class="contact-item">
                        <i class="fas fa-envelope"></i>
                        <div>support&#64;taveelo.com</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="copyright">
                © {{ 'Copyright' | lang }} <a href="#">Taveelo</a>. {{ 'All Rights Reserved.' | lang }}
            </div>

            <div class="social-links">
                <a href="https://www.facebook.com/people/Taveelo/61579426213535/" target="_blank" rel="noopener noreferrer" title="Facebook"><i class="fab fa-facebook-f"></i></a>
                <a href="https://www.instagram.com/taveelo_ae/" target="_blank" rel="noopener noreferrer" title="Instagram"><i class="fab fa-instagram"></i></a>
            </div>
        </div>
    </div>
</footer>
<style>
    /* Footer - WHITE */
    footer {
        background: #ffffff !important;
        color: #0c2f6e;
        padding: 24px 40px 18px;
        border-top: 1px solid #e0e0e0;
        display: block !important;
        position: relative !important;
        z-index: 20 !important;
        width: 100% !important;
        box-sizing: border-box;
    }

    .footer-container {
        max-width: 1400px;
        margin: 0 auto;
    }

    .footer-main {
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
    }

    .footer-brand {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        flex-wrap: wrap;
        gap: 25px;
    }

    .footer-logo {
        font-family: 'Outfit', sans-serif;
        font-size: 36px;
        font-weight: 700;
        color: #4dd0ce;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .footer-contact {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
    }

    .contact-item {
        display: flex;
        align-items: center;
        gap: 15px;
        font-size: 14px;
        line-height: 1.6;
    }

    .contact-item i {
        color: #4dd0ce;
        font-size: 20px;
        margin-top: 0;
    }

    .contact-phone {
        color: #4dd0ce;
        font-size: 18px;
        font-weight: 600;
        text-decoration: none;
    }

    .footer-section h3 {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
        position: relative;
        padding-bottom: 12px;
    }

    .footer-section h3::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 40px;
        height: 2px;
        background: #4dd0ce;
    }

    .footer-links {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .footer-links a {
        color: #0c2f6e;
        text-decoration: none;
        font-size: 14px;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .footer-links a:hover {
        color: #4dd0ce;
        padding-left: 8px;
    }

    .footer-links a i {
        font-size: 10px;
    }

    .newsletter {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .newsletter input {
        padding: 14px 18px;
        border: 1px solid #e0e0e0;
        border-radius: 10px;
        background: #f5f5f5;
        color: #0c2f6e;
        font-size: 14px;
    }

    .newsletter input::placeholder {
        color: #999;
    }

    .newsletter button {
        padding: 14px;
        background: #4dd0ce;
        border: none;
        border-radius: 10px;
        color: #0a1f4d;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
    }

    .newsletter button:hover {
        background: #5edcda;
        transform: translateY(-2px);
    }

    .security-badge {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: #666;
        margin-top: 10px;
    }

    .footer-bottom {
        border-top: 1px solid #e0e0e0;
        padding-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .copyright {
        color: #666;
        font-size: 14px;
    }

    .copyright a {
        color: #4dd0ce;
        text-decoration: none;
    }

    .social-links {
        display: flex;
        gap: 15px;
    }

    .social-links a {
        width: 40px;
        height: 40px;
        background: #f5f5f5;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0c2f6e;
        text-decoration: none;
        transition: all 0.3s;
        border: 1px solid #e0e0e0;
    }

    .social-links a:hover {
        background: #4dd0ce;
        color: #ffffff;
        transform: translateY(-3px);
        border-color: #4dd0ce;
    }

    /* Mobile Menu */
    .mobile-menu-btn {
        display: none;
        background: none;
        border: none;
        color: #0c2f6e;
        font-size: 24px;
        cursor: pointer;
    }

    /* Responsive */
    @media (max-width: 1024px) {
        .content-wrapper {
            grid-template-columns: 1fr;
            gap: 40px;
        }

        .b2b-info {
            text-align: center;
        }

        .b2b-title {
            font-size: 42px;
        }

        .stats-grid {
            grid-template-columns: repeat(2, 1fr);
        }

        .footer-main {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 768px) {
        .header-container {
            padding: 0 20px;
        }

        nav {
            display: none;
        }

        .mobile-menu-btn {
            display: block;
        }

        .main-section {
            padding: 40px 20px;
        }

        .b2b-title {
            font-size: 32px;
        }

        .login-container {
            padding: 40px 30px;
        }

        .login-logo {
            font-size: 36px;
        }

        .stats-grid {
            grid-template-columns: 1fr;
        }

        .footer-main {
            grid-template-columns: 1fr;
            gap: 40px;
        }

        .footer-bottom {
            flex-direction: column;
            gap: 20px;
            text-align: center;
        }
    }
</style>